import React from "react";
import { SectionHeading } from "./SectionHeading";
import { valueBlocks } from "../data/landing";
const reassurances = ["No complicated teaching plans.", "No theology degree required.", "No rigid study schedule."];
export function ValueSection() {
  return <section className="bg-canvas" data-id="element-295" data-mp="iecuigqchzsn">
      <div className="mx-auto max-w-6xl px-5 py-16 md:py-24" data-id="element-296" data-mp="if4h521ysn6s">
        <SectionHeading eyebrow="A Complete Christian Faith Resource" title={<>
              Everything Your Family Needs to Start Exploring the{" "}
              <span className="text-royal" data-id="element-298" data-mp="8mqapvzxysea">WHY Behind Faith.</span>
            </>} data-id="element-297" data-mp="df9mcnf2jdgg" />

        <ul className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5" data-id="element-299" data-mp="3n3vxi4gt43d">
          {valueBlocks.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex flex-col rounded-3xl bg-white p-6 shadow-[0_10px_30px_-18px_rgba(11,24,56,0.25)] md:p-7" data-id="element-300" data-mp="3qt4lxn6tso8z">
              <span className="flex h-14 w-14 items-center justify-center rounded-2xl bg-royal-light" data-id="element-301" data-mp="3lvuy2bz34kn9">
                <Icon className="h-7 w-7 text-royal" strokeWidth={2} aria-hidden="true" data-id="element-302" data-mp="1j7qiqynjbsbn" />
              </span>
              <h3 className="mt-5 font-display text-xl font-extrabold leading-tight text-ink" data-id="element-303" data-mp="1o2ebxathhawk">{title}</h3>
              <p className="mt-2 leading-relaxed text-ink-soft" data-id="element-304" data-mp="1eaqcammrwnk0">{text}</p>
            </li>)}
        </ul>

        <p className="mt-10 flex flex-col items-center justify-center gap-2 text-center font-display text-lg font-bold text-navy md:flex-row md:gap-4" data-id="element-305" data-mp="220kqb7itwi5u">
          {reassurances.map((line, i) => <React.Fragment key={line} data-id="element-306" data-mp="1szwjoxvrlk2z" data-mpi={i}>
              {i > 0 && <span aria-hidden="true" className="hidden text-gold-deep md:inline" data-id="element-307" data-mp="1sz4sdz97a8ii">•</span>}
              <span data-id="element-308" data-mp="1xx6767zlflo6">{line}</span>
            </React.Fragment>)}
        </p>
      </div>
    </section>;
}